import React from 'react';
import PropTypes from 'prop-types';

import './Hero.scss';

const Hero = ({ children, position = 'top' }) => (
  <aside className={`hero hero--${position}`}>
    {children}
  </aside>
);

Hero.propTypes = {
  children: PropTypes.any,
};

Hero.defaultProps = {
  children: null,
};

export default Hero;
